import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FILTER_KEY = 'quick_filter_attribute';

export const useQuickFilterSectionAttributeOpenedState = () => {
  return useOpenedStateManager(FILTER_KEY);
};
